import { useQuery } from '@tanstack/react-query';

/**
 * Improved paginated request hook for React Query.
 * - Sets keepPreviousData: true by default for better UX.
 * - Accepts all React Query options.
 *
 * @param {Function} queryFn - Function that returns a promise for the data.
 * @param {Array} queryKey - Unique key for the query (should include page, size, filters, etc.)
 * @param {Object} options - Additional React Query options.
 */

export default function usePaginatedQuery(queryFn, queryKey, options = {}) {
  return useQuery({
    queryKey,
    queryFn,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    ...options,
  });
}
